import Box from "@mui/material/Box";
import { getSafeAreaTop } from "./safeArea";

type SafeAreaTopProps = {
  children: React.ReactNode;
};

const SafeAreaTop: React.FC<SafeAreaTopProps> = ({ children }) => {
  return <Box sx={{ paddingTop: getSafeAreaTop() }}>{children}</Box>;
};

export default SafeAreaTop;